<template>
	<div class="input-multifile">
		<vue-dropzone ref="uploader" :id="_uid.toString()" :options="options" @vdropzone-file-added="upload"></vue-dropzone>
	</div>
</template>

<script>
	export default {
		props: ['url', 'name'],
		computed: {
			options() {
				return {
					url: this.url,
					autoProcessQueue: false
				};
			}
		},
		methods: {
			async upload(file) {
				try {
					let upload = {};
					upload[this.name] = file;
					const data = await this.$upload(this.url, upload);
					this.$emit('upload', data[this.name]);
				} catch(e) {
					if(e.code && e.code === 413) {
						this.$setErrors(['File too large']);
					}
					console.log(e);
				}
				this.$refs.uploader.removeFile(file);
			}
		}
	}
</script>